import React from "react";
import PropTypes from "prop-types";

const Confirm = ({
  className
}) => /*#__PURE__*/React.createElement("svg", {
  className: className,
  width: "84",
  height: "84",
  viewBox: "0 0 84 84",
  fill: "#8AC149",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.9642 84C24.4716 84.002 8.8132 73.1403 2.67231 56.7445C-3.46858 40.3487 1.19677 21.8596 14.3791 10.3494C27.5615 -1.16073 46.4945 -3.27642 61.888 5.04049C62.5745 5.38295 63.2391 5.76769 63.878 6.19248C65.3643 7.10285 65.8359 9.04467 64.9329 10.5365C64.0063 12.0188 62.0607 12.4789 60.5693 11.5684C60.0179 11.2564 59.4425 10.8965 58.891 10.6085C43.474 2.26601 24.286 6.37714 13.6311 20.3057C2.97613 34.2342 4.01435 53.849 16.08 66.5725C28.1457 79.2961 47.6602 81.3545 62.1103 71.428C76.5603 61.5015 81.6601 42.5341 74.1396 26.6883L43.4267 57.4321C42.8307 58.0331 42.019 58.3702 41.173 58.3681C40.3337 58.3719 39.5289 58.0341 38.9433 57.4321L26.2602 44.7602C25.0287 43.5143 25.0394 41.5049 26.2841 40.2723C27.5288 39.0396 29.5361 39.0503 30.7676 40.2963L41.173 50.7122L72.6531 19.2004C73.3492 18.5288 74.304 18.1956 75.2664 18.2884C76.252 18.3879 77.1367 18.9369 77.664 19.7764C85.7231 32.7427 86.1211 49.0649 78.7033 62.4093C71.2856 75.7537 57.2199 84.0197 41.9642 84Z"
}));

Confirm.propTypes = {
  className: PropTypes.string
};
export default Confirm;